import { render, staticRenderFns } from "./CadastroReleases.vue?vue&type=template&id=b00c3592"
import script from "./CadastroReleases.vue?vue&type=script&lang=js"
export * from "./CadastroReleases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports